import { Button } from '@cibli/shared';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import MainLayout from '@/features/common/components/MainLayout';
import PictureCapture, { PictureCaptureRef } from '@/features/picture/components/PictureCapture';

interface InterviewPhotoProps {
  onValidate: (imageBase64: string | null) => void;
  onSkip: () => void;
  onCancel: () => void;
}

export default function InterviewPhotoScreen({
  onValidate,
  onSkip,
  onCancel,
}: InterviewPhotoProps) {
  const { t } = useTranslation();
  const pictureCaptureRef = useRef<PictureCaptureRef | null>(null);

  const handleImageCapture = (imageBase64: string | null) => {
    onValidate(imageBase64);
  };

  return (
    <MainLayout className="gap-12" onClose={onCancel}>
      <div className="max-w-sm mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-center">{t('Interview.Photo.title')}</h1>
      </div>
      <PictureCapture ref={pictureCaptureRef} onImageCapture={handleImageCapture} size="lg" />
      <Button variant="ghost" onClick={onSkip} className="text-lg text-muted-foreground">
        {t('Interview.Photo.skip')}
      </Button>
    </MainLayout>
  );
}
